import styles from './AppStoreLinks.module.css';

export const AppStoreLinks = () => {
  return (
    <div className={styles.appStoreLinks} data-testid="app-store-links">
      App Store Links
    </div>
  );
};
